// 评论

import api from '../lib/api'
import assign from 'lodash.assign'
import * as commentUtils from '../lib/commentUtils'
import Cookie from 'js-cookie'

const name = 'comment'

const DEFAULT_PLACEHOLDER = '欢迎分享交流，您的留言将由作者筛选后显示'

export default {
  name,
  namespaced: true,
  state () {
    return {
      submited: false, // 视频评论页专用，监听提交成功，执行返回视频页操作

      wid: '', // 章节id

      list: [], // 留言列表
      topList: [], // 置顶留言
      selfList: [], // 用户自己的留言，允许自己看到，别人不一定能看到（有被精选的可能）

      pageNo: 1, // 当前页码
      teacherList: [], // 角色信息
      // userInfo: {}, // 用户信息
      replyItem: {}, // 当前要回复的一条数据(一级)
      replyLastItem: {}, // 上一个回复的数据(一级或二级)
      sending: false, // 正在发送
      popup: {
        show: false, // 是否展示评论浮层
        content: '', // 评论浮层内容
        placeholder: DEFAULT_PLACEHOLDER // 输入框 placeholder
      }
    }
  },
  getters: {
    totalCommentList (state) {
      return commentUtils.unique(state.topList, state.selfList, state.list)
    }
  },
  mutations: {
    // 通用设置
    set (state, data) {
      assign(state, data)
    },

    // 展示评论浮层
    toggleCommentPopup (state) {
      state.popup.show = !state.popup.show
    },

    // 增加页码
    addPageNo (state) {
      state.pageNo++
    },

    // 添加一条评论
    appendOneComment (state, [data, roles]) {
      state.list.push(computeRole(data, roles))
    },

    // 更新置顶留言
    appendTopComment (state, [data, roles]) {
      if (!data.length) return

      data[0].topTag = true

      state.topList = computeRole(data, roles)
    },

    // 更新用户自己的留言
    appendSelfComment (state, data) {
      if (data) {
        data.forEach(item => (item.self = true))
        state.selfList = data
      }
    },

    // 顶上一条评论
    unshiftOneComment (state, data) {
      state.selfList.unshift(data)
    },

    // 添加一条回复
    appendOneReplay (state, data) {
      state.replyItem.replyList.push(data)
    }
  },
  actions: {
    // 初始化评论
    async initComment ({ commit, dispatch }, { wid }) {
      commit('set', { wid })
      // await dispatch('getUserInfo')
      dispatch('getList')
    },

    // 获取当前用户信息
    async getUserInfo ({ dispatch }) {
      await dispatch('getUserInfo', null, { root: true })
    },

    // 获取评论列表
    async getList ({ state: { wid, pageNo }, commit }, { zid = 1, pageSize = 10 } = {}) {
      const { data: { list, top, self, teacherList } } = await api.media.getCommentData({ wid, zid, pageNo, pageSize })

      // 第一页包含 置顶留言 和 用户自己的留言
      if (pageNo === 1) {
        commit('appendSelfComment', self)
        commit('appendTopComment', [top, teacherList])
      }

      list.forEach(item => commit('appendOneComment', [item, teacherList]))
      commit('addPageNo')
    },

    // 回复
    async commentReply ({ state: {  replyLastItem }, commit, rootState: { userInfo } }, { item, subItem }) {
      console.log(userInfo)
      const targetItem = subItem.id ? subItem : item
      const isSelf = String(targetItem.userId) === String(userInfo.userid) // 点的是自己
      const isSameAsLast = String(targetItem.userId) === String(replyLastItem.userId) // 点的和上一个相同
      switch (true) {
        case isSelf && isSameAsLast: // 这次是自己, 上次也是自己, 不用管
          break
        case isSelf && !isSameAsLast: // 这次是自己, 上次不是自己
          commit('set', {
            replyItem: item,
            replyLastItem: targetItem,
            popup: {
              show: true,
              content: '',
              placeholder: DEFAULT_PLACEHOLDER
            }
          })
          break
        case !isSelf && isSameAsLast: // 这次不是自己, 和上次一样, 不用管
          break
        case !isSelf && !isSameAsLast: // 这次不是自己, 和上次不一样
          commit('set', {
            replyItem: item,
            replyLastItem: targetItem,
            popup: {
              show: true,
              content: '',
              placeholder: `回复 ${targetItem.userName}:`
            }
          })
          break
      }
    },

    // 发送评论
    async sendOneComment ({ commit, state: { sending, wid, popup, replyItem, replyLastItem }, rootState: { userInfo } }, { zid = 1, score = 5 }) {
      console.log(userInfo)
      // 判断正在发送
      if (sending) {
        return
      }

      // 判断输入内容
      const restext = popup.content // 输入内容
      if (!restext) {
        return
      }

      try {
        // 开始发送
        commit('set', {
          sending: true
        })

        // 组织传参
        const isSelf = replyLastItem.userId === String(userInfo.userid) // 是否是自己
        const isReply = !isSelf && popup.placeholder.indexOf('回复') === 0 // 是否是回复
        const commentId = isReply ? replyItem.id : '' // 回复id(一级)
        const fid = isReply ? replyLastItem.id : '' // 回复id(一级或二级)
        const retype = isReply ? 2 : 1 // 类型, 2:回复, 1:评论
        const { data } = await api.media.sendComment({ commentId, fid, restext, wid, zid, score, retype, userId: Cookie.get('openid') }) // 发送

        // 添加
        commit(isReply ? 'appendOneReplay' : 'unshiftOneComment', data)

        // 清空重置
        commit('set', {
          replyItem: {},
          replyLastItem: {},
          sending: false,
          popup: {
            show: false,
            content: '',
            placeholder: DEFAULT_PLACEHOLDER
          }
        })
      } catch (e) {
        commit('set', {
          sending: false
        })
      }
    },

    // 视频评论里要设置一下 courseId
    setChapterId ({ commit }, chapterId) {
      commit('set', { wid: chapterId })
    },

    // 视频评论的提交方法
    async sendFromComment4Video ({ commit, state: { wid } }, content) {
      const { msg } = await api.media.sendComment({
        wid,
        restext: content,
        score: 5,
        zid: 1,
        userId: Cookie.get('openid')
      })

      if (msg === 'success') {
        commit('set', { submited: true })
      }
    }
  }
}

// 计算评论角色
function computeRole (data, roles) {
  roles.forEach(role => {
    data.role = data.userId === role.userId ? role.role : null
  })

  return data
}
